import { styled } from "styled-components";

import StarIcon from "@/assets/icons/star.svg?react";
import { getRandomInt } from "@/utils";

const starsPosition = [
  {
    x: 25,
    y: 25,
  },
  {
    x: 3,
    y: 90,
  },
  {
    x: 20,
    y: 160,
  },
  {
    x: 5,
    y: 300,
  },
  {
    x: 93,
    y: 40,
  },
  {
    x: 75,
    y: 220,
  },
  {
    x: 89,
    y: 330,
  },
];

const Star = styled(StarIcon)`
  @keyframes scale {
    0% {
      transform: scale(0.4);
    }
    50% {
      transform: scale(1);
    }
    100% {
      transform: scale(0.4);
    }
  }

  animation-name: scale;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  z-index: -1;
`;

export const Stars = () => {
  return starsPosition.map(({ x, y }, i) => (
    <Star
      key={i}
      style={{
        position: "absolute",
        left: `${x}%`,
        top: `${y}px`,
        animationDuration: `${getRandomInt(2000, 2500) * (i + 1)}ms`,
      }}
    />
  ));
};
